export const getDefaultState = () => ({
  cachedFiles: [],
});
export const state = getDefaultState();
